import { render } from "./TyreExclusiveOrder.vue?vue&type=template&id=0a75e72c&scoped=true"
import script from "./TyreExclusiveOrder.vue?vue&type=script&lang=js"
export * from "./TyreExclusiveOrder.vue?vue&type=script&lang=js"

import "./TyreExclusiveOrder.vue?vue&type=style&index=0&id=0a75e72c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a75e72c"]])

export default __exports__